import type { RootState } from '@portal-types/store';

export const whitelabelAssets = (state: RootState) => state.whitelabel.data?.assets;
export const whitelabelGtmId = (state: RootState) => state.whitelabel.data?.gtmId;
export const whitelabelLinks = (state: RootState) => state.whitelabel.data?.links;
export const whitelabelPages = (state: RootState) => state.whitelabel.data?.pages;
export const whitelabelPalette = (state: RootState) => state.whitelabel.data?.palette;
export const whitelabelTitle = (state: RootState) => state.whitelabel.data?.title;
